import { createContext, useState } from "react";

export const AuthContext = createContext({})

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState()

    const signin = async (cpf, password) => {
      password = btoa(password)
      var sgin = await fetch(process.env.REACT_APP_HML_AUTH_USER,{
        headers: { "Content-Type": "application/json","Authorization" : "Bearer "+ process.env.REACT_APP_HML_AUTH_USER_TOKEN },
        method: 'POST',
        body: JSON.stringify({cpf,password})
      })
      sgin = await sgin.json()
      return sgin
    };

    const signup = async (cpf, password,email,name) => {
      password = btoa(password)
      var sgup = await fetch(process.env.REACT_APP_HML_CREATE_USER,{
        headers: { "Content-Type": "application/json","Authorization" : "Bearer " + process.env.REACT_APP_HML_CREATE_USER_TOKEN },
        method: 'POST',
        body: JSON.stringify({cpf,password,email,name})
      })
      sgup = await sgup.json()
      return sgup
    };

    const changepswd = async(username,email,code,password)=>{
      password = btoa(password)
      var chpswd = await fetch(process.env.REACT_APP_HML_CHANGE_PSWD,{
        headers: { "Content-Type": "application/json","Authorization" : "Bearer " + process.env.REACT_APP_HML_CHANGE_PSWD_TOKEN },
        method: 'POST',
        body: JSON.stringify({username,email,code,password})
      })
      chpswd = await chpswd.json()
      return chpswd
    }

    return <AuthContext.Provider value={{ user, signed: !!user, signin, signup, changepswd }}>{children}</AuthContext.Provider>
}